import React from 'react';

export const EditorialImageCard = ({
  image,
  alt,
  kicker,
  title,
  description,
  testId,
  minHeight = 'min-h-[24rem]',
  captionAlign = 'left'
}) => {
  const captionClass = captionAlign === 'center' ? 'text-center items-center' : 'text-left items-start';

  return (
    <div className={`editorial-image-shell ${minHeight}`} data-testid={testId}>
      <img src={image} alt={alt} data-testid={`${testId}-image`} />
      <div className="absolute inset-0 bg-gradient-to-t from-[rgba(12,12,12,0.86)] via-[rgba(12,12,12,0.18)] to-transparent" />
      <div className={`absolute inset-x-5 bottom-5 glass-card tracing-panel p-5 flex flex-col ${captionClass}`} data-testid={`${testId}-caption`}>
        {kicker && <p className="text-[10px] uppercase tracking-[0.18em] text-[#f7f5f0]/70">{kicker}</p>}
        {title && <p className="mt-2 text-lg text-white font-medium max-w-xl">{title}</p>}
        {description && <p className="mt-2 text-sm text-[#f7f5f0]/82 max-w-xl">{description}</p>}
      </div>
    </div>
  );
};
